// extracted by mini-css-extract-plugin
module.exports = {"link":"SevenAddElectronicSalePoint_link__3lI0C","inline":"SevenAddElectronicSalePoint_inline__21ccn"};